var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['siderTrigger', _vm.collapsed ? 'collapsed' : ''],on:{"click":_vm.handleChange}},[_c('Icon',{style:({margin: '0 20px'}),attrs:{"type":"md-menu","size":"24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }